module.exports = "././img/geografia_logo.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/geografia_logo.svg
// module id = 121
// module chunks = 0